import React from "react";
import PropTypes from 'prop-types';
import Select from "react-select";

function RuleSelection({ ruleType, setActionableResources, updateRuleType, resetState }) {
  const handleTypeUpdate = (type) => {
    setActionableResources(type);
    updateRuleType(type);
    resetState();
  };

  const renderTypeDropdown = () => (
    <Select
      name="select-rule-type"
      className="select-rule-type"
      value={ruleType}
      options={[
        { value: "Rule::Label::CollectionAssociation",
          label: t("If added to label, then add to collection") },
        { value: "Rule::Tag::CollectionAssociation",
          label: t("If tagged, then add to collection") },
        { value: "Rule::Tag::LabelAssociation",
          label: t("If tagged, then add to label") },
        { value: "Rule::Tag::SectionAssociation",
          label: t("If tagged, then move to section") }
      ]}
      clearable={false}
      searchable={false}
      onChange={(option) => handleTypeUpdate(option.value)}
      placeholder={t('Select Rule')}
    />
  );

  return (
    <React.Fragment>
      {renderTypeDropdown()}
    </React.Fragment>
  );
}

RuleSelection.propTypes = {
  ruleType: PropTypes.string,
  updateRuleType: PropTypes.func.isRequired,
  setActionableResources: PropTypes.func.isRequired,
  resetState: PropTypes.func.isRequired
};

RuleSelection.defaultProps = {
  ruleType: null
};

export default RuleSelection;
